import type { useGT } from 'gt-react';
import type { SalesOrderLineItem } from '@erp/rpc';

export function effectiveMaxJoins(item: {
  maxJoins?: number | null;
  productDefaultMaxJoins?: number | null;
}): number | null {
  if (item.maxJoins != null) return item.maxJoins;
  if (item.productDefaultMaxJoins != null) return item.productDefaultMaxJoins;
  return null;
}

export function formatContinuity(
  maxJoins: number | null,
  gt: ReturnType<typeof useGT>,
): string {
  if (maxJoins == null) {
    return gt('Standard Inventory', {
      context: 'maxJoins unset — standard inventory path',
    });
  }
  if (maxJoins === 0) {
    return gt('1 piece', { context: 'maxJoins=0 one continuous piece' });
  }
  return gt('≤{count} pieces', {
    context: 'maxJoins k means at most k+1 pieces',
    count: maxJoins + 1,
  });
}

export function formatArchetype(
  archetype: SalesOrderLineItem['demandArchetype'],
  gt: ReturnType<typeof useGT>,
): string {
  if (archetype === 'cut_to_length') {
    return gt('Cut-to-Length', { context: 'demand handling' });
  }
  if (archetype === 'whole_package') {
    return gt('Whole Package', { context: 'demand handling' });
  }
  if (archetype === 'unknown') {
    return gt('unknown', { context: 'demand archetype' });
  }
  return gt('unscored', { context: 'demand archetype missing' });
}
